import { CompaniesVersionsService_companyVersionServiceGetLatest } from '@festina/legalentity-general-types/legalentity/hooks/CompaniesVersionsService_companyVersionServiceGetLatest'

export const useLazyFetchCompanyVersionLatest =
  CompaniesVersionsService_companyVersionServiceGetLatest.useLazyQuery
